"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const native_1 = require("@react-navigation/native");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_hyperlink_1 = __importDefault(require("react-native-hyperlink"));
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const IconComment_1 = __importDefault(require("../../../assets/icons/IconComment"));
const IconLike_1 = __importDefault(require("../../../assets/icons/IconLike"));
const IconLiked_1 = __importDefault(require("../../../assets/icons/IconLiked"));
const images_1 = require("../../../assets/images");
const components_1 = require("../../../components");
const IconThreeDoc_1 = __importDefault(require("../../../components/Icon/IconThreeDoc"));
const ModalSuccess_1 = __importDefault(require("../../../components/modal/ModalSuccess"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const tooltips_1 = require("../../../components/tooltips");
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const Article_1 = __importDefault(require("../../../networking/apis/Article"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const ItemUser_1 = __importDefault(require("../ListCommentScreen/component/ItemUser"));
const styles_1 = __importDefault(require("./styles"));
const DetailCommentArticle = (props) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { postId, articleId } = props?.route?.params;
    const [visibleLike, setVisibleLike] = (0, react_1.useState)(false);
    const [visibleModalSuccess, setVisibleModalSuccess] = (0, react_1.useState)(false);
    const [page, setPage] = (0, react_1.useState)(1);
    const [reloadPage, setReloadPage] = (0, react_1.useState)(false);
    const [dataCallApi, setDataCallApi] = (0, react_1.useState)([]);
    const [listData, setListData] = (0, react_1.useState)([]);
    const [dataComment, setDataComment] = (0, react_1.useState)(null);
    const [numberLikes, setNumberLikes] = (0, react_1.useState)(dataComment?.likes || 0);
    const [like, setLike] = (0, react_1.useState)(false);
    const [articleTitle, setArticleTitle] = (0, react_1.useState)('');
    const [loadMore, setLoadMore] = (0, react_1.useState)(false);
    const [numberComment, setNumberComment] = (0, react_1.useState)(dataComment?.comments || 0);
    const dataUser = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile, react_redux_1.shallowEqual);
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const isFocused = (0, native_1.useIsFocused)();
    const isAnonymous = dataUser?.registration_status == 0;
    (0, react_1.useEffect)(() => {
        if (isFocused) {
            reloadScreen();
        }
    }, [isFocused]);
    const reloadScreen = () => {
        setReloadPage(true);
        callApiComment(1);
        setPage(1);
    };
    (0, react_1.useEffect)(() => {
        if (dataComment) {
            setLike(dataComment?.is_liked != 0);
            setNumberLikes(dataComment?.likes);
            setNumberComment(dataComment?.comments || 0);
        }
    }, [dataComment]);
    (0, react_1.useEffect)(() => {
        if (connected) {
            callApiDetail();
        }
    }, [connected]);
    const callApiDetail = async () => {
        await Article_1.default.getArticleDetail(articleId).then((res) => {
            setArticleTitle(res.data.data?.title);
        });
    };
    (0, react_1.useEffect)(() => {
        if (postId && listData?.length > 0) {
            reloadScreen();
        }
    }, [postId]);
    (0, react_1.useEffect)(() => {
        let data = [];
        if (reloadPage == false) {
            if (dataCallApi) {
                data = listData.concat(dataCallApi);
                setListData(data);
                setLoadMore(false);
            }
        }
        else {
            if (dataCallApi) {
                data = dataCallApi;
                setListData(data);
                setReloadPage(false);
                setLoadMore(false);
            }
        }
    }, [dataCallApi]);
    const callApiComment = async (data) => {
        await Article_1.default.CommentDetail({ comment: postId, page: data })
            .then((res) => {
            setDataCallApi(res?.data?.article_comments?.data);
            setDataComment(res?.data);
        })
            .catch((err) => {
            console.log('err', err);
        });
    };
    const confirmLike = async () => {
        if (like) {
            await Article_1.default.unlikeArticleComment(postId)
                .then((_res) => {
                setLike(false);
                setNumberLikes(numberLikes - 1);
            })
                .catch((err) => {
                console.log('err', err);
            });
        }
        else {
            await Article_1.default.likeArticleComment(postId)
                .then((_res) => {
                setLike(true);
                setNumberLikes(numberLikes + 1);
            })
                .catch((err) => console.log(err));
        }
    };
    const handleLoadMore = () => {
        if (dataCallApi) {
            if (dataCallApi?.length < 8) {
                setLoadMore(false);
                return false;
            }
            else {
                setLoadMore(true);
                setPage(page + 1);
                callApiComment(page + 1);
            }
        }
        return false;
    };
    const displayTweet = (data) => {
        let listcomments = listData.filter((item) => item?.article_comment_id != data);
        setListData(listcomments);
        setNumberComment(numberComment - 1);
    };
    const headFlatlist = () => {
        return (react_1.default.createElement(react_native_1.View, { style: { paddingTop: (0, scale_1.scale)(24) } },
            react_1.default.createElement(react_native_1.View, { style: {
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    marginBottom: (0, scale_1.scale)(12),
                    paddingHorizontal: (0, scale_1.scale)(16),
                } },
                react_1.default.createElement(react_native_1.Image, { source: dataComment?.thumbnail_url
                        ? { uri: dataComment?.thumbnail_url }
                        : images_1.images.AvatarDefaul, style: {
                        height: (0, scale_1.scale)(42),
                        width: (0, scale_1.scale)(42),
                        marginRight: (0, scale_1.scale)(12),
                        borderRadius: 99,
                    } }),
                react_1.default.createElement(react_native_1.View, { style: { width: (0, scale_1.scale)(240), justifyContent: 'center' } },
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                            fontSize: (0, scale_1.moderateScale)(14),
                            lineHeight: (0, scale_1.moderateScale)(21),
                            color: '#292A33',
                        } }, dataComment?.nickname),
                    react_1.default.createElement(CustomText_1.default, { style: {
                            fontSize: (0, scale_1.moderateScale)(10),
                            lineHeight: (0, scale_1.moderateScale)(17),
                            fontWeight: '300',
                            color: '#545454',
                            marginTop: (0, scale_1.scale)(4),
                        } }, `@${dataComment?.user_handle}`)),
                react_1.default.createElement(react_native_1.View, { style: {
                        width: (0, scale_1.scale)(50),
                        alignItems: 'flex-end',
                        justifyContent: 'center',
                        transform: [{ rotate: '90deg' }],
                    } },
                    react_1.default.createElement(react_native_1.View, { style: { transform: [{ rotate: '90deg' }] } },
                        react_1.default.createElement(IconThreeDoc_1.default, { data: dataComment, uri: `${window.location.origin}/article/detail-comment?postId=${postId}&articleId=${articleId}`, displayTweet: (_data) => {
                                (0, rootNavigation_1.goBack)();
                            } })))),
            react_1.default.createElement(react_native_hyperlink_1.default, { onPress: (url) => react_native_1.Linking.openURL(url), linkStyle: {
                    color: '#06c',
                    textDecorationLine: 'underline',
                } },
                react_1.default.createElement(CustomText_1.default, { style: {
                        color: '#292A33',
                        fontSize: (0, scale_1.moderateScale)(15),
                        fontWeight: '300',
                        lineHeight: (0, scale_1.moderateScale)(23),
                        marginTop: (0, scale_1.scale)(8),
                        marginHorizontal: (0, scale_1.scale)(16),
                    } }, dataComment?.comment_text)),
            react_1.default.createElement(react_native_1.View, { style: { marginHorizontal: (0, scale_1.scale)(16), marginTop: (0, scale_1.scale)(8) } },
                react_1.default.createElement(tooltips_1.DateTimeTooltip, { title: (0, moment_1.default)(dataComment?.created_at).format('YYYY/MM/DD HH:mm') }, `${(0, helpler_1.stringToDateFormat)(dataComment?.created_at)} `)),
            react_1.default.createElement(react_native_1.View, { style: {
                    flexDirection: 'row',
                    marginTop: (0, scale_1.scale)(12),
                    marginHorizontal: (0, scale_1.scale)(16),
                } },
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                        color: '#292A33',
                        fontSize: (0, scale_1.moderateScale)(12),
                        lineHeight: (0, scale_1.moderateScale)(18),
                    }, onPress: () => {
                        setVisibleLike(true);
                    } },
                    numberLikes,
                    react_1.default.createElement(CustomText_1.default, { style: {
                            color: '#545454',
                            fontWeight: '300',
                            fontSize: (0, scale_1.moderateScale)(12),
                        } }, "\u4EF6\u306E\u3044\u3044\u306D")),
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                        color: '#292A33',
                        fontSize: (0, scale_1.moderateScale)(12),
                        lineHeight: (0, scale_1.moderateScale)(18),
                        marginLeft: (0, scale_1.scale)(16),
                    } },
                    numberComment,
                    react_1.default.createElement(CustomText_1.default, { style: {
                            color: '#545454',
                            fontWeight: '300',
                            fontSize: (0, scale_1.moderateScale)(12),
                        } }, "\u4EF6\u306E\u30B3\u30E1\u30F3\u30C8"))),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.viewLike },
                react_1.default.createElement(react_native_1.TouchableOpacity, { style: { marginRight: (0, scale_1.scale)(32) }, onPress: () => {
                        if (isAnonymous) {
                            return dispatch(slice_1.default.actions.showRequestLoginModal());
                        }
                        (0, rootNavigation_1.navigate)(Routes_1.default.REP_COMMENT_ARTICLE, {
                            article: articleId,
                            comment: postId,
                            type: 'POST',
                        });
                    } },
                    react_1.default.createElement(IconComment_1.default, { color: dataComment?.numberLikes > 0 ? '#44A06B' : '#545454', height: (0, scale_1.scale)(28) })),
                react_1.default.createElement(react_native_1.TouchableOpacity
                // style={{backgroundColor:'red'}}
                , { 
                    // style={{backgroundColor:'red'}}
                    onPress: () => {
                        if (isAnonymous) {
                            return dispatch(slice_1.default.actions.showRequestLoginModal());
                        }
                        confirmLike();
                    } }, like ? (react_1.default.createElement(IconLiked_1.default, { height: (0, scale_1.scale)(28) })) : (react_1.default.createElement(IconLike_1.default, { height: (0, scale_1.scale)(28), color: '#545454' }))))));
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.View, { style: {
            flex: 1,
            backgroundColor: '#F7F7F7',
        } },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, title: articleTitle || '  ', styleContainer: {
                backgroundColor: 'white',
                marginBottom: 0,
            }, leftIcon: react_1.default.createElement(BackHeader_1.default, { color: '#292A33' }), onLeftPress: () => (0, rootNavigation_1.goBack)() }),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
            react_1.default.createElement(react_native_1.FlatList, { data: listData, keyExtractor: (item) => item?.article_comment_id, renderItem: (item) => (react_1.default.createElement(ItemUser_1.default, { data: item?.item, articleId: articleId, target_comment_id: postId, displayTweet: (data) => displayTweet(data) })), showsVerticalScrollIndicator: false, ListHeaderComponent: () => headFlatlist(), contentContainerStyle: { paddingBottom: (0, scale_1.scale)(60) }, refreshing: reloadPage, onRefresh: reloadScreen, onEndReachedThreshold: 0.1, onEndReached: handleLoadMore }),
            loadMore ? (react_1.default.createElement(react_native_1.View, { style: {
                    position: 'absolute',
                    width: '100%',
                    bottom: (0, scale_1.scale)(0),
                } },
                react_1.default.createElement(react_native_1.ActivityIndicator, { size: "small", color: '#286D84' }))) : null),
        react_1.default.createElement(ModalSuccess_1.default, { visible: visibleModalSuccess, onClose: () => setVisibleModalSuccess(false), content: "\u30B3\u30E1\u30F3\u30C8\u3057\u307E\u3057\u305F" })));
};
exports.default = DetailCommentArticle;
